import React from "react";
import PropTypes from "prop-types";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

// import ContractService from "../../services/contract.service";
//Import module Modal
import Modal from "react-bootstrap/Modal";

function ModalContract(props) {
  // const [data, setData] = useState([]);

  // useEffect(() => {
  //   getData(props.data.person_card_id);
  // }, [props.data.person_card_id]);

  const handleClose = () => {
    props.setShow(false);
  };

  // const getData = (person_card_id) => {
  //   ContractService.getContractByID({ thai_no: person_card_id }).then(
  //     (response) => {
  //       setData(response.data.data);
  //       console.log(data);
  //     }
  //   );
  // };

  const dateFormatter = (cell) => {
    const getdate = new Date(cell);
    return (
      <p>
        {getdate.toLocaleString("th-TH", {
          year: "2-digit",
          month: "short",
          day: "numeric",
        })}
      </p>
    );
  };

  const headerSortingStyle = {
    backgroundColor: "#D4EFDF",
    verticalAlign: "center",
  };

  const columns = [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      csvExport: false,
    },
    {
      text: "ปีที่ส่ง",
      dataField: "season",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      filter: textFilter({
        placeholder: "ปีทีส่ง",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "เลขสัญญา",
      dataField: "contract_no",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "15%" };
      },
      headerSortingStyle,
      filter: textFilter({
        placeholder: "เลขสัญญา",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "รหัสโรงงาน",
      dataField: "factory_code",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      filter: textFilter({
        placeholder: "รหัสโรงงาน",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "โรงงาน",
      dataField: "factory_name_th",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "25%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "left",
      },
      filter: textFilter({
        placeholder: "โรงงาน",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "ยอดจด (ตัน)",
      dataField: "contract_cane",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "right",
      },
    },
    {
      text: "ส่งจริง (ตัน)",
      dataField: "delivered_cane",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "right",
      },
    },
    {
      text: "เริ่มสัญญา",
      formatter: dateFormatter,
      dataField: "contract_date",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
    },
    // {
    //   text: "แก้ไข",
    //   dataField: "edit",
    //   isDummyField: true,
    //   editable: false,
    //   formatter: actionsViewFormatter,
    //   headerStyle: () => {
    //     return { verticalAlign: "middle", width: "10%" };
    //   },
    //   headerSortingStyle,
    // },
  ];

  // const headers = [
  //   ...columns.map((a) => {
  //     return { label: a.text, key: a.dataField, csvExport: a.csvExport };
  //   }),
  // ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>รายละเอียดคู่สัญญา</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BootstrapTable
            pagination={pagination}
            keyField="id"
            data={props.data}
            columns={columns}
            loading={true}
            filter={filterFactory()}
            // headerClasses="header-class"
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ปิด
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalContract;

ModalContract.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  data: PropTypes.array,
  // years: PropTypes.array,
  // import: PropTypes.func,
  // delete: PropTypes.func,
  // setdata: PropTypes.func,
  // onsubmit: PropTypes.func,
};
ModalContract.defaultProps = {
  data: [],
};
